// Copyright (c) StrangeBee 2024

import { PATTERN_ROUTES, PatternType, PATTERN_ROUTES_FLAT } from '@Constants/patternsRoute';

type PregMatchReturn = (m: any, s: string) => string;

const pregMatch =
    (params: Record<string, string>): PregMatchReturn =>
    (_: string, submatch: string): string => {
        return params[submatch] || _;
    };

export const replace = (path = '', params: Record<string, string>): string => {
    return path.replace(/:([a-zA-Z]+)((?=\/|\?|&)*)/g, pregMatch(params));
};

const isAvailablePath = (path: string | PatternType): path is PatternType => {
    return PATTERN_ROUTES_FLAT.includes(path);
};

const RouteBuilder = (lib: any) => {
    const delimiter = '/';

    const objectExplorer = (pathAttr: PatternType): false | string[] => {
        const props = pathAttr.split('.').reduce((g: any, attr: string): any | false => {
            if (!g) {
                return false;
            }
            return g[attr];
        }, lib);

        if (props.default) {
            return props.default;
        }

        return props;
    };

    return {
        compute: (routeName: PatternType, params = {}): string => {
            try {
                if (!isAvailablePath(routeName)) {
                    return '';
                }

                const path = objectExplorer(routeName);

                return path ? replace(delimiter + path.join(delimiter), params) : '';
            } catch (error) {
                console.error(error, routeName, params); // eslint-disable-line
                return '';
            }
        },
    };
};

export default RouteBuilder(PATTERN_ROUTES);
